// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-checked-date .anticon {\n  margin-right: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
